import { render, staticRenderFns } from "./RetailerProductSizeModal.vue?vue&type=template&id=7c623d61"
import script from "./RetailerProductSizeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./RetailerProductSizeModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CImg/CImg.vue').default,RetailerProductModal: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/RetailerProduct/RetailerProductModal.vue').default})
